import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { VerticalStepper } from './VerticalStepper';

const Questions = () => {
	return (
		<Box position={'relative'} marginBottom={0}>
			<Grid>
				<Grid item md={4} data-aos={'fade-up'} padding={1}>
					<Box display='flex'>
						<Box
							sx={{
								width: 1,
								height: 1,
								overflow: 'hidden'
							}}>
							<Box display={'flex'} flexDirection={{ xs: 'column', md: 'row' }} position={'relative'}>
								<Box
									display={'flex'}
									/* alignItems={'center'} */
									width={1}
									order={{ xs: 2, md: 1 }}
									justifyContent='flex-start'>
									<Box width={1} display='flex' marginBottom={2} justifyContent='flex-start'>
										<VerticalStepper />
									</Box>
								</Box>
							</Box>
						</Box>

						<Box
							component={'img'}
							src={
								'https://149814860.v2.pressablecdn.com/wp-content/uploads/2021/07/12.-Unstuck-with-calming.png'
							}
							boxShadow={24}
							sx={{
								maxWidth: { xs: 250, sm: 250, md: 380, lg: 400 },
								marginTop: 'auto',
								marginBottom: 'auto',
								height: 'auto',
								alignContent: 'center',
								right: 0,
								display: { xs: 'none', md: 'block' },
								borderRadius: '50% 50% 50% 50%'
							}}
						/>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export { Questions };
